import { Link, useNavigate } from 'react-router-dom'
import SectionTitle from '../../../components/SectionTitle/SectionTitle'
import './ProgramPreview.css'
import { Avatar, Flex, Loader, Skeleton } from '@mantine/core'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { ROUTES_PATHNAME } from '../../../routes/dict'


export default function ProgramPreview() {

    const [state, setState] = useState({ data: null, isLoading: false })
    const [currentTab, setCurrentTab] = useState('highlights')

    useEffect(() => {
        const getData = async () => {
            try {
                const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/program-preview/`
                setState(prev => ({ ...prev, isLoading: true }))
                const { data } = await axios.get(URL)

                setState(prev => ({ ...prev, data }))

            } catch (error) {
                console.log(error)
            } finally {
                setState(prev => ({ ...prev, isLoading: false }))
            }
        }
        getData()
    }, [])



    return (
        <section id='programas' className="programs ">
            <Flex direction={{base: 'column', md:'row'}} align='end'>
                <SectionTitle
                upText='Programas'
                downText='Experiencias de formación'
            />

            <div class="program-filters">
                <button onClick={() => setCurrentTab('highlights')} className={`pf-btn ${currentTab === 'highlights' ? "active" : ""}`}>Destacados</button>
                <button onClick={() => setCurrentTab('nexts')} className={`pf-btn ${currentTab === 'nexts' ? "active" : ""}`}>Próximos inicios</button>
            </div>
            </Flex>

            <div className="programs-grid">
                {state.isLoading && <>
                    <Skeleton h='250px' w='100%' animate />
                    <Skeleton h='250px' w='100%' animate />
                    <Skeleton h='250px' w='100%' animate />
                    <Skeleton h='250px' w='100%' animate />
                </>}


                {state.data && state.data[currentTab]?.length > 0 ? (
                    state.data[currentTab].map(item => (
                        <ProgramCard
                            key={item._id}
                            academicUnitName={item.comercialInformation.name}
                            academicUnitId={item._id}
                            classQuantity={item.comercialInformation.classQuantity}
                            specialtyName={item.specialties}
                            teachers={item.teachers}
                            currentStudents={item.students?.length}
                            totalViews={item?.stats?.views}
                            initialDate={item.comercialInformation.initialDate}
                        />
                    ))
                ) : (
                    !state.isLoading && <p className='program-no-content-text'>No hay programas disponibles.</p>
                )}

            </div>

            <Flex w='100%' justify='center' mt={16}>
                <Link to="/capacitaciones" className="manifesto-cta ">
                    Ver todos los programas
                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </Link>
            </Flex>


        </section>
    )
}



const getDaysUntil = (dateString) => {
    if (!dateString) return null;

    // Diccionario para normalizar meses de español a inglés o número
    const months = {
        "enero": 0, "febrero": 1, "marzo": 2, "abril": 3, "mayo": 4, "junio": 5,
        "julio": 6, "agosto": 7, "septiembre": 8, "octubre": 9, "noviembre": 10, "diciembre": 11
    };

    // Limpiamos el string: "05 DE MAYO 2026" -> ["05", "MAYO", "2026"]
    const parts = dateString.toLowerCase().split(" ").filter(p => p !== "de");

    const day = parseInt(parts[0]);
    const month = months[parts[1]];
    const year = parseInt(parts[2]);

    if (isNaN(month)) return null; // Por si el formato falla

    const targetDate = new Date(year, month, day);
    const today = new Date(); // Hoy es 21 de Abril de 2026 según el sistema

    // Resetear horas para comparar solo días
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Empieza hoy";
    if (diffDays === 1) return "Empieza mañana";
    if (diffDays < 0) return "Ya comenzó. ¡Sumate!";

    return `Empieza en ${diffDays} días`;
};

const ProgramCard = ({
    specialtyName,
    academicUnitName,
    classQuantity,
    initialDate,
    currentStudents,
    totalViews,
    teachers,
    academicUnitId
}) => {

    const navigate = useNavigate()


    const teachersList = Array.isArray(teachers) ? teachers : (teachers ? [teachers] : []);

    const startText = getDaysUntil(initialDate);

    return (
        <div className="program-card">
            <div className="pc-left">
                <div className="pc-category">{specialtyName}</div>
                <div className="pc-title">{academicUnitName}</div>
                <div className="pc-features">
                    <div className="pc-feature">
                        <div className="pc-feature-dot green"></div>
                        {classQuantity} sesiones en vivo
                    </div>
                    {startText && (
                        <div className="pc-feature">
                            <div className="pc-feature-dot blue"></div>
                            {startText}
                        </div>
                    )}
                    <div className="pc-feature">
                        <div className="pc-feature-dot orange"></div>
                        Mentoría grupal
                    </div>
                </div>
                <div className="pc-live">
                    <div className="pc-live-dot"></div>
                    {totalViews > 0 ? `${totalViews} personas están interesadas en este programa` : currentStudents > 0 ? `${currentStudents} veterinarios cursando ahora` : '¡Estamos abriendo este programa!'}
                </div>
            </div>
            <div className="pc-right">
                <div className="pc-mentor">
                    {teachersList?.map((t, idx) => {
                        if (idx > 0) return
                        return <div key={t._id || idx}>
                            <Flex justify='end' >
                                <Avatar src={t.profilePicture} alt={`${t.name} ${t.lastname}`} /></Flex>
                            <div className="pc-mentor-name">{`${t.name} ${t.lastname}`}</div>
                            <div className="pc-mentor-role">Docente</div>
                        </div>
                    })}
                </div>
                <button className="pc-cta" onClick={() => navigate(`${ROUTES_PATHNAME.courses.href}/${academicUnitId}`)}>Ver programa →</button>
            </div>
        </div>
    )
}